export default __webpack_public_path__ + "static/media/bitcoin.ee707b62.webp";